import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import clioLogo from '../../../../assets/logo_clio_sm.svg';
import { baseStyleSheet } from '../../../../styles/styles';
import { ClioIntegrationGraphic } from '../../../svgs/graphics/ClioIntegrationGraphic';
import { IntegrationCard, useIntegrationCard } from '../IntegrationCard';
import { clioColor, styleSheet } from './styles';

export const DashboardClioV2IntegrationCard = () => {
	const { getLogoImgProps, getCloseButtonProps, getCtaButtonProps, getIntegrationTitleProps, showCard } =
		useIntegrationCard({
			closeIntegrationEventName: 'ClioV2IntegrationClosed',
			enableUrlPath: `/integrations/${Api.IntegrationProvider.Clio}`,
			integrationEnableEventName: 'ClioV2IntegrationEnableClick',
			pendingAction: Api.PendingActions.ConnectClioV2,
			checkApiPendingAction: true,
		});

	if (!showCard) {
		return null;
	}

	return (
		<IntegrationCard
			logoBgColor={clioColor}
			closeButtonProps={getCloseButtonProps()}
			IntegrationGraphic={ClioIntegrationGraphic}
			headerLabel='Clio Integration (V2)'
			logoImgProps={getLogoImgProps({
				alt: 'Clio Logo',
				className: css(styleSheet.logo),
				src: clioLogo,
			})}
			ctaButtonProps={getCtaButtonProps({
				children: 'Connect with Clio V2',
				styleDeclaration: [baseStyleSheet.ctaButtonReverse, styleSheet.ctaButton],
			})}
			integrationTitleProps={getIntegrationTitleProps({
				styleDeclaration: styleSheet.integrationTitle,
			})}
		>
			<p>Enhanced Integration Available!</p>
			<p>
				We are excited to announce that you can integrate your Clio account with Levitate using our new V2 integration.
				With this enhanced integration, we will have the ability to pull client information, including names, email,
				phone number, birthdays, anniversaries, and more &mdash; making staying in touch even easier. We can also push
				our notes into Clio.
			</p>
		</IntegrationCard>
	);
};
